import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	brandsSelector: 'js-m-customer-lounge-brand-intro__brand-select',
};

@createModule('CustomerLoungeBrandIntro')
/**
 * @author 
 */

export class CustomerLoungeBrandIntro extends TerrificSpec {
	$ctx: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);

		this.openOtherUrl();

		resolve();
	}
	stop() {}

	openOtherUrl() {
		const $brandSelect = this.$ctx.find(`.${classes.brandsSelector}`);
		var curBrand = $brandSelect.find("option:selected").text();
		$brandSelect.on("change",function(ev: Event){
			var brand = $(ev.currentTarget).find("option:selected").text();
			var brandUrl = $(ev.currentTarget).val();
			brandUrl = brandUrl.toString();
			if (brand!==curBrand) {
				window.location.href = brandUrl;
			}
		})
	}
}
